import { connect } from 'react-redux';
import UpdatePassword from '../../components/login/UpdatePassword';
import { updatePassword } from '../../actions/user.actions';

const mapDispatchToProps = dispatch => ({
    updatePassword: (email, password, key) => dispatch(updatePassword({email, password, key})),
});
export default connect(null, mapDispatchToProps)(UpdatePassword);
